import React from "react"
import { Divider, IconButton, Tabs, Tab } from '@material-ui/core';
import addIcon from "../../../../images/add-case.svg";
import saveIcon from "../../../../images/save.svg";
import { makeStyles } from '@material-ui/core/styles';
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { convertToLocalTime, getCaseStateIcon, isUserInRole, parseJwtToken, urlToB64 } from "../../../../commonFunctions/commonFunctions";
import { ADMIN } from "../../../../Constantes/userRoles";
import { selectCurrentCase } from "../../../../redux/currentCase/selectors";
import { InputClickToCall } from "./InputClickToCall";
import { FactoryMenu } from "./FactoryMenu";
import { selectContractCase } from "../../../../redux/contract/selectors";
import { selectUserRoles, selectUserSuperAdmin } from "../../../../redux/authentication/selectors";
import templateIcon from "../../../../images/layout.svg"
import messageIcon from "../../../../images/paperplane.svg"
import historyIcon from "../../../../images/history.svg"
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    fontSize: 20,
  },
  dividerH: {
    marginLeft: 10,
    marginRight: 10
  },
  clickToCallEditButton:{
    fontSize: "1.12rem",
    padding: "0 5px",
    color: "#000"
  },
  secondTlfNumber:{
    color: "#ff3d3d !important"
  },
  tabItem: {
    textTransform: "none",
    fontWeight: "normal",
    fontSize: "0.875rem",
    minWidth: "auto",
    padding: 0,
    marginRight: "1.5rem"
  }
}));

function isFactoryCase(currentCase){

  if(!currentCase)
      return false;

  const factoryStates = window.getConfig("FACTORY_CASE_STATE_IDS");
  const factoryEntryChannels = window.getConfig("FACTORY_ENTRY_CHANNEL_IDS")

  const isFactoryState = factoryStates.some(factoryState => factoryState === currentCase.stateId)
  const isFactoryEntryChannel = factoryEntryChannels.some(factoryEntryChannel => factoryEntryChannel === currentCase.entryChannelId)

  return isFactoryState || isFactoryEntryChannel

}

function Header(props){
  const { t } = useTranslation();
    const {loading, currentCase, saveChanges, createCase,showNewCase,setShowNewCase,closed,plate,changeBlock,checkBlockClickToCall,showCallTable, editClickToCall, setEditClickToCall, handleChangeClickToCall, saveClickToCall, cancelEditClickToCall, phoneNumber, setShowFullHistory, currentTab, setCurrentTab, canViewBillingTabs} = props;
    const isLoading = loading === "succeeded" || loading === "updating" ? true : (loading === "failed" || loading === "loading") && currentCase !== null? true: false;
    const headerRedux = useSelector(selectCurrentCase)
    const userRoles = useSelector(selectUserRoles);
    const userSuperAdmin = useSelector(selectUserSuperAdmin)
    const classes= useStyles()
    const user = parseJwtToken();
    const canUserSave = user!=null && (  isUserInRole(ADMIN, userRoles, userSuperAdmin) || currentCase?.blockedByUserId == user.userId || !currentCase?.blockedByUserId);
    const contractCase = useSelector(selectContractCase);

    return(
      <div className={"caseform-nav"}>
        {canViewBillingTabs && (
          <div style={{ width: "100%", borderBottom: "1px solid #e0e0e0", paddingLeft: "1.5rem", paddingRight: "1.5rem", boxSizing: "border-box" }}>
            <Tabs
              value={currentTab}
              onChange={(e, val) => setCurrentTab(val)}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab className={classes.tabItem} disableRipple label={t("CaseTabs.Dispatch")} />
              <Tab className={classes.tabItem} disableRipple label={t("CaseTabs.PaymentOrders")} />
            </Tabs>
          </div>
        )}
        {currentTab === 0 && (
          <>
            <div className="caseform-nav-actions">
                <div style={{paddingLeft: "1.5rem", paddingRight: "1.5rem"}}>
                  {headerRedux? 
                  <div style={{fontSize: "1.5rem", alignItems: "center", display: "grid", gridTemplateColumns: "1.25rem 1fr", columnGap: "0.5rem"}}>{headerRedux.stateId && <img style={{width: "1.25rem"}} src={getCaseStateIcon(headerRedux.stateId)}/>} {headerRedux.taxonomyLevel_1?.value ? headerRedux.taxonomyLevel_1.value : showNewCase ? t("NewCase") : ""}</div>
                  :<div style={{height: "1.25rem"}} className={"placeholder-space"}></div> 
                  }
                </div>
                <div style={{display: "flex", alignItems: "center"}}>
                  {/* {currentCase && isFactoryCase(contractCase) && !closed && !showNewCase && <FactoryMenu processId={currentCase?.factoryProcessId} showForms={props.handleShowForms} disabledButtom={props.disabledButtom} showAddFactoryCommentForm={props.showAddFactoryCommentForm} showRegressFactoryCaseForm={props.showRegressFactoryCaseForm} showAdvanceFactoryCaseForm={props.showAdvanceFactoryCaseForm} regressCase={props.regressCase} disabledRegressCase={props.disabledRegressCase}/>} */}
                  {/*{currentCase && !closed && !showNewCase && <IconButton onClick={changeBlock}>{currentCase.blockedByUser? <span className="case-header-icon-wrapper"><i className="icon icon-lock-closed icon-red" title={`${t("CaseBlockedBy")} ${currentCase? currentCase.blockedByUser: t("User")}`}/></span> : <span className="case-header-icon-wrapper"><i className="icon icon-lock-open icon-black" title={t("BlockCase")}/> </span>}</IconButton>} */}
                  <IconButton disabled={plate == undefined ? true : false} onClick={setShowNewCase}><img style={showNewCase ? {transform: "rotate(45deg)"} : {}} src={addIcon} alt={`${t("Save")}`} title={!showNewCase  ? t("NewCase") : t("DiscardCase")} height={20}/></IconButton> 
                  <IconButton disabled={currentCase === null || (!canUserSave ? true : closed) || !isLoading || currentTab === 1} onClick={showNewCase == true ? createCase : saveChanges}><span className="case-header-icon-wrapper"><img src={saveIcon} alt={t("Save")} title={`${t("Save")} ${t("Case")}`}/></span></IconButton> 
                  {/* <IconButton id="template-button" title={t("CustomProcessModel")} disabled={props.disabledButtom.documentation} onClick={() => props.handleShowForms("documentation")}><span style={{width: "20px" ,height: "20px"}}><img height={20} src={templateIcon}/></span></IconButton>*/}
                  <IconButton id="message-button" title={`${t("Send")} ${t("Message")}`} disabled={props.disabledButtom.messageForm} onClick={() => props.handleShowForms("messageForm")}><img height={20} src={messageIcon}/></IconButton> 
                  <IconButton id="full-history-button" title={t("CaseHistory")} onClick={setShowFullHistory} disabled={currentCase === null || showNewCase}><img height={20} src={historyIcon}/></IconButton>
                </div>
            </div>
                  <Divider orientation="horizontal" flexItem style={{width: "100%", height: "1px"}}/>

            <div className="caseform-nav-info">
                  {((currentCase != null && currentCase.caseId != undefined && currentCase.caseId > 0) || showNewCase) &&
                  <>
                    <span style={{display: "flex", alignItems: "center"}}><b style={{marginRight: "0.2rem"}}>{t("CaseId")}:</b> { !showNewCase ? currentCase.caseId : " guarde para generar"}
                    {showCallTable?<div id={"callTableIcon"} onClick={() => props.handleShowForms("callTable")} className={"callTableIcon"} role="button" title={"Llamadas del caso"}><i className="icon icon-alert-info-filled icon-small"></i></div>  :<></>}  
                    </span>
                    <span><b>{t("Agent")}: </b>{isLoading && currentCase ? currentCase.user: <div className={"placeholder-space"}></div> }</span>
                    <span><b>{t("CreatedAt")}:</b> { isLoading && !showNewCase ? dayjs(convertToLocalTime(currentCase.creationDate)).format("DD/MM/YYYY HH:mm"):  showNewCase ? dayjs(new Date()).format("DD/MM/YYYY"):''}</span>
                    <span><b>{t("ClosedAt")}:</b> {isLoading&& !showNewCase && dayjs(convertToLocalTime(currentCase.closeDate)).format("DD/MM/YYYY HH:mm") !== "Invalid Date" ?
                    dayjs(convertToLocalTime(currentCase.closeDate)).format("DD/MM/YYYY HH:mm")
                    : <div style={{display:"inline"}}>-</div>}</span>

                    <span style={{display: "flex"}}><b style={{marginRight: "0.2rem"}}>Tel.: </b>{isLoading && currentCase?.phoneNumber 
                      ? <> <span style={{display: !editClickToCall?  "none" : "flex"}}><InputClickToCall onChange={handleChangeClickToCall} value={phoneNumber}/><span style={{display:"flex", alignItems:"baseline"}}><IconButton title={t("Save")} classes={{root: classes.clickToCallEditButton}} onClick={saveClickToCall}><i className={"icon icon-save"}></i></IconButton><IconButton title={t("Cancel")} classes={{root: classes.clickToCallEditButton}} onClick={cancelEditClickToCall}><i className="icon icon-close"></i></IconButton></span></span>
                          {/* <span style={{display: editClickToCall?  "none" : "flex"}}> <a id="clickToCall" onClick={e=>checkBlockClickToCall(e)} title="Iniciar llamada" style={{color:"#000"}} href={`tel:${phoneNumber}:${currentCase.plate || plate || 0}:${currentCase.caseId}:${0}:ALPHABET:BMW:${urlToB64(currentCase.caseId)}:0`}> {phoneNumber}</a> {!closed && <IconButton title={t("EditPhone")} classes={{root: classes.clickToCallEditButton}} onClick={()=>setEditClickToCall(true)}><i className={"icon icon-edit"}></i></IconButton>}  </span>      */}
                          <span style={{display: editClickToCall?  "none" : "flex"}}><span>{phoneNumber}</span>  {!closed && <IconButton title={t("EditPhone")} classes={{root: classes.clickToCallEditButton}} onClick={()=>setEditClickToCall(true)}><i className={"icon icon-edit"}></i></IconButton>}  </span>
                        </>               
                      : <><span style={{display: !editClickToCall?  "none" : "flex"}}><InputClickToCall onChange={handleChangeClickToCall} value={phoneNumber}/><span style={{display:"flex", alignItems:"baseline"}}><IconButton title={t("Save")} classes={{root: classes.clickToCallEditButton}} onClick={saveClickToCall}><i className={"icon icon-save"}></i></IconButton><IconButton title={t("Cancel")} classes={{root: classes.clickToCallEditButton}} onClick={cancelEditClickToCall}><i className="icon icon-close"></i></IconButton></span></span>
                        <span style={{display: editClickToCall?  "none" : "flex"}}><span>-</span> {currentCase?.caseId !== 0 && !closed && <IconButton title={t("EditPhone")} classes={{root: classes.clickToCallEditButton}} onClick={()=>setEditClickToCall(true)}><i className={"icon icon-edit"}></i></IconButton>}</span>
                        </>
                      }
                    </span>  
                  </>
                }
            </div>
          </>
        )}
     </div>

  )

}


export { Header }